/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import { WidgetGuard } from 'features/types'
import {
  MetricsEmptyResultGuard,
  MetricsLanguageNotSupportedGuard,
  TopicInaccessibleGuard,
  TopicIndexNotReadyGuard,
  UnexpectedServiceErrorGuard,
  ThemeInaccessibleGuard
} from '../../../../share/guards'

const TopicsModeWidgetDataGuards: WidgetGuard = ({ widgetId, children }) => (
  <TopicInaccessibleGuard widgetId={widgetId}>
    <TopicIndexNotReadyGuard widgetId={widgetId}>
      <ThemeInaccessibleGuard widgetId={widgetId}>
        <UnexpectedServiceErrorGuard widgetId={widgetId}>
          <MetricsLanguageNotSupportedGuard widgetId={widgetId}>
            <MetricsEmptyResultGuard widgetId={widgetId}> {children}</MetricsEmptyResultGuard>
          </MetricsLanguageNotSupportedGuard>
        </UnexpectedServiceErrorGuard>
      </ThemeInaccessibleGuard>
    </TopicIndexNotReadyGuard>
  </TopicInaccessibleGuard>
)

export default TopicsModeWidgetDataGuards
